import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import huyl1 from "../../../assets/images/CustomersPartners/huyl1.webp";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa";
import khach1 from "../../../assets/images/CustomersPartners/khach1.webp";
import khach2 from "../../../assets/images/CustomersPartners/khach2.webp";
import khach3 from "../../../assets/images/CustomersPartners/khach3.webp";
import khach4 from "../../../assets/images/CustomersPartners/khach4.webp";
import khach5 from "../../../assets/images/CustomersPartners/khach5.webp";
import khach6 from "../../../assets/images/CustomersPartners/khach6.webp";
import khach7 from "../../../assets/images/CustomersPartners/khach7.webp";
import khach9 from "../../../assets/images/CustomersPartners/khach9.webp";
import khach10 from "../../../assets/images/CustomersPartners/khach10.webp";
export default function CustomersPartnersSlide() {
  const profiles = [
    { src: huyl1, name: "Trần Quốc Đạt", position: "Giám đốc" },
    { src: khach1, name: "Phạm Thị Bích", position: "Trưởng phòng chuyên môn" },
    { src: khach5, name: "Vũ Hoàng Long", position: "Trưởng phòng kinh doanh" },
    {
      src: khach2,
      name: "Đỗ Thị Lan",
      position: "Giám đốc trung tâm giáo dục",
    },
    {
      src: khach6,
      name: "Nguyễn Văn Khánh",
      position: "Giám đốc trung tâm thể hình",
    },
    {
      src: khach3,
      name: "Ngô Thanh Tú",
      position: "Nhân viên văn phòng",
    },
    {
      src: khach9,
      name: "Lê Thị Hương",
      position: "Giám đốc trung tâm giáo dục",
    },
    {
      src: khach10,
      name: "Bùi Khả Hân",
      position: "Quản lý chuyên môn",
    },
    {
      src: khach4,
      name: "Phạm Hùng Huy",
      position: "Nhân viên văn phòng",
    },
    {
      src: khach7,
      name: "Trần Quang Khải",
      position: "Trưởng phòng kinh doanh",
    },
  ];

  return (
    <div className="w-full">
      <div className="block md:hidden">
        <Swiper
          spaceBetween={10}
          slidesPerView={1}
          navigation={{
            nextEl: ".next-btn",
            prevEl: ".prev-btn",
          }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          loop={true}
          modules={[Navigation, Autoplay]}
        >
          {profiles.map((profile, index) => (
            <SwiperSlide key={index}>
              <div className="flex flex-col w-full  gap-3   rounded-[8px] relative group">
                <div className="w-full flex items-center justify-between">
                  <img
                    src={profile.src}
                    className="w-full h-auto  object-cover rounded-lg"
                    alt={profile.name}
                  />
                  {/* Overlay on hover */}
                  <div className="absolute top-0 left-0 w-full h-full bg-boo bg-opacity-50 rounded-lg flex flex-col items-start px-[36px] py-[40px] justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <p className="text-white text-[32px] font-semibold absolute bottom-10">
                      {profile.name}
                    </p>
                    <p className="text-white text-[18px] font-medium absolute bottom-2">
                      {profile.position}
                    </p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="flex justify-center mt-4 gap-3">
          <button className="prev-btn bg-white text-black rounded-full border-2 border-[#E2E2E2] border-solid flex items-center justify-center w-10 h-10">
            <FaAngleLeft />
          </button>
          <button className="next-btn bg-white text-black rounded-full border-2 border-[#E2E2E2] border-solid flex items-center justify-center w-10 h-10">
            <FaAngleRight />
          </button>
        </div>
      </div>

      <div className="hidden md:block">
        <Swiper
          spaceBetween={10}
          slidesPerView={3}
          navigation={{
            nextEl: ".next-btn",
            prevEl: ".prev-btn",
          }}
          autoplay={{
            delay: 0,
            delay: 3000,
            disableOnInteraction: false,
          }}
          loop={true}
          speed={5000}
          modules={[Navigation, Autoplay]}
        >
          {profiles.map((profile, index) => (
            <SwiperSlide key={index}>
              <div className="flex flex-col w-full gap-3 rounded-[8px] px-[24px] py-[20px] relative group">
                <div className="w-full flex items-center justify-center relative">
                  <img
                    src={profile.src}
                    className="w-full h-auto object-cover rounded-lg"
                    alt={profile.name}
                  />
                  {/* Overlay on hover */}
                  <div className="absolute top-0 left-0 w-full h-full bg-boo bg-opacity-50 rounded-lg flex flex-col items-start px-[36px] py-[40px] justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <p className="text-white text-[32px] font-semibold absolute bottom-10">
                      {profile.name}
                    </p>

                    <p className="text-white text-[18px] font-medium absolute bottom-2">
                      {profile.position}
                    </p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="flex justify-center gap-3 mt-4">
          <button className="prev-btn bg-white text-black rounded-full border-2 border-[#E2E2E2] border-solid flex items-center justify-center w-10 h-10">
            <FaAngleLeft />
          </button>
          <button className="next-btn bg-white text-black rounded-full border-2 border-[#E2E2E2] border-solid flex items-center justify-center w-10 h-10">
            <FaAngleRight />
          </button>
        </div>
      </div>
    </div>
  );
}
